import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { Properties } from '../api';
import { dispatchForm } from '../forms';
import { GuestReportForms } from './guest-report.forms';
import { GuestReportStore, guestReportStore } from './guest-report.store';

export class GuestReportService {
  constructor(
    private readonly guestReportApi: Properties.GuestReportApi,
    private readonly store: GuestReportStore
  ) {}

  startGuestReport(propertyId: string, request: Properties.StartGuestReportRequest) {
    from(this.guestReportApi.propertyIdGuestreportStartPost(propertyId, request))
      .pipe(
        map(({ data }) => data.data),
        dispatchForm(GuestReportForms.StartGuestReport)
      )
      .subscribe(report => this.store.update({ report }));
  }

  submitGuestReport(
    propertyId: string,
    userId: string,
    reservationId: string,
    notes?: string,
    photo?: File
  ) {
    from(
      this.guestReportApi.propertyIdGuestreportSubmitPost(
        propertyId,
        userId,
        reservationId,
        notes,
        photo
      )
    )
      .pipe(
        map(({ data }) => data),
        dispatchForm(GuestReportForms.SubmitGuestReport)
      )
      .subscribe(({ maintenanceTicketNumber }) => this.store.update({ maintenanceTicketNumber }));
  }

  reset() {
    this.store.reset();
  }
}

export const guestReportService = new GuestReportService(
  new Properties.GuestReportApi(),
  guestReportStore
);
